import { useQuery } from '@tanstack/react-query';

import { getLogsByServiceModelAndId } from '~/services/AuditService';

// The hook accepts raw route/prop values and owns trimming before query-key or API usage.
export function normalizeAuditModelId(modelId?: string | null) {
  return modelId?.trim() ?? '';
}

export type AuditEventModelType = 'promo' | 'voucher' | 'marketing_router' | (string & {});

export const auditEventQueryKeys = {
  all: ['audit-events'] as const,
  lists: () => [...auditEventQueryKeys.all, 'list'] as const,
  model: (serviceName: string, modelType: string, modelId: string, limit: number, timeFrameMonths: number) =>
    [...auditEventQueryKeys.lists(), serviceName, modelType, modelId, limit, timeFrameMonths] as const,
};

type Params = {
  serviceName?: string;
  modelType: AuditEventModelType;
  modelId?: string | null;
  limit?: number;
  timeFrameMonths?: number;
  enabled?: boolean;
};

export function useGetAuditEventsByModel({
  serviceName = 'svc-promo',
  modelType,
  modelId,
  limit = 5,
  timeFrameMonths = 24,
  enabled = true,
}: Params) {
  const normalizedModelId = normalizeAuditModelId(modelId);

  const query = useQuery({
    queryKey: auditEventQueryKeys.model(serviceName, modelType, normalizedModelId, limit, timeFrameMonths),
    queryFn: async () =>
      getLogsByServiceModelAndId(serviceName, modelType, normalizedModelId, 1, limit, true, timeFrameMonths),
    enabled: enabled && Boolean(modelType && normalizedModelId),
  });

  return {
    ...query,
    normalizedModelId,
  };
}
